export default "__VITE_ASSET__655bb843__"